'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _actions = require('../../utils/actions');

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

var _applyStyles = require('../../utils/apply-styles');

var _applyStyles2 = _interopRequireDefault(_applyStyles);

var _actions2 = require('../actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var inViewportWatcher = void 0; /** @jsx dom */


var handleAnimateFinnished = function handleAnimateFinnished() {
	inViewportWatcher.dispose();
	inViewportWatcher = null;
};

var afterMount = function afterMount(_ref, el) {
	var props = _ref.props;
	var animation = props.animation,
	    duration = props.duration,
	    iterations = props.iterations;


	if (animation && animation !== 'none' && duration && iterations) {
		inViewportWatcher = (0, _actions.animate)(animation, duration, iterations, el, handleAnimateFinnished);
	}
};

var beforeUnmount = function beforeUnmount() {
	if (inViewportWatcher) {
		inViewportWatcher.dispose();
		inViewportWatcher = null;
	}
};

var conditionsUnmet = function conditionsUnmet(props) {
	var conditionTrigger = props.conditionTrigger,
	    conditionVariable = props.conditionVariable,
	    conditionOperator = props.conditionOperator,
	    conditionValue = props.conditionValue;


	if (!conditionTrigger || conditionTrigger === 'NONE') {
		return false;
	}

	if (conditionTrigger && conditionTrigger === 'VARIABLE' && conditionVariable) {
		var value = (0, _actions2.getDescendantProp)(props, conditionVariable);

		return !(0, _actions2.operatorCheck)(conditionOperator, value, conditionValue);
	}

	return false;
};

var render = function render(_ref2) {
	var props = _ref2.props;
	var children = props.children,
	    marginBottom = props.marginBottom,
	    marginTop = props.marginTop,
	    maxWidth = props.maxWidth,
	    maxHeight = props.maxHeight,
	    paddingHorizontal = props.paddingHorizontal,
	    paddingVertical = props.paddingVertical,
	    textCenter = props.textCenter,
	    hideOnMobile = props.hideOnMobile,
	    hideOnTablet = props.hideOnTablet,
	    hideOnDesktop = props.hideOnDesktop;

	var conditionAction = props.conditionAction || 'SHOW';

	var styles = {
		'max-width': maxWidth,
		'max-height': maxHeight,
		'margin-top': marginTop,
		'margin-bottom': marginBottom,
		'padding-bottom': paddingVertical,
		'padding-top': paddingVertical,
		'padding-left': paddingHorizontal,
		'padding-right': paddingHorizontal
	};

	styles = (0, _applyStyles2.default)(styles, props, ['background', 'border']);

	var classes = {
		'CMS-Container-hideOnMobile': !hideOnMobile,
		'CMS-Container-hideOnTablet': !hideOnTablet,
		'CMS-Container-hideOnDesktop': !hideOnDesktop
	};

	if (conditionAction === 'SHOW' && conditionsUnmet(props) || conditionAction === 'HIDE' && !conditionsUnmet(props)) {
		return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)('noscript', null), props);
	}

	return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['Container', props.class, classes, !props.styleClasses.Container && textCenter && 'u-textCenter', props.styleClasses.Container], 'data-style-attr': 'Container', style: !props.styleClasses.Container && styles },
		children
	), props);
};

exports.default = { afterMount: afterMount, beforeUnmount: beforeUnmount, render: render };